import classNames from "classnames";
import { Col, Form } from "react-bootstrap";
import PaymentMethodIcon from "../../eshop/order/components/paymentMethodIcon/paymentMethodIcon";
import visa from "../../eshop/order/components/paymentMethodIcon/assets/ic-visa.png";
import masterCard from "../../eshop/order/components/paymentMethodIcon/assets/ic-master-card.png";
import applePay from "../../eshop/order/components/paymentMethodIcon/assets/ic-apple-pay.png";
import * as React from "react";
import { observer } from "mobx-react-lite";
import { DataTestIds } from "../../../data-test-constants";
import { ViewComponent } from "@frui.ts/views";
import SelectPaymentMethodViewModel from "../../../viewModels/common/payment/selectPaymentMethodViewModel";
import { getValidationMessage } from "../../../utils/validationPatch";
import { EshopFormIds } from "../../eshop/test-ids-constants";
import { PaymentType } from "../../../models/payment";
import { icGooglePay } from "../../eshop/order/components/paymentMethodIcon/assets/ic-google-pay";
import { registerView } from "@frui.ts/views/dist";
import { speedometerFastIcon } from "../../../utils/icons/speedometerFast";
import { speedometerSlowIcon } from "../../../utils/icons/speedometerSlow";
import styles from "./selectPaymentMethod.module.scss";
import ReactMarkdown from "react-markdown";

const SelectPaymentMethod: ViewComponent<SelectPaymentMethodViewModel> = observer(({ vm }) => {
  const validationError = getValidationMessage(vm.chargeOrder, "paymentType");

  const handlePaymentChange = (paymentType: PaymentType) => {
    if (
      (paymentType === PaymentType.PayGate && !vm.payGateDisabled) ||
      (paymentType === PaymentType.GooglePay && !vm.payGateDisabled) ||
      (paymentType === PaymentType.Transfer && !vm.transferDisabled)
    ) {
      vm.chargeOrder.paymentType = paymentType;
    }
  };

  return (
    <>
      <div className={classNames("mb-3", { "is-invalid": validationError })}>
        {/* Platební kartou */}
        <div
          className={classNames(styles.paymentCard, {
            [styles.selected]: vm.chargeOrder.paymentType === PaymentType.PayGate,
            [styles.disabled]: vm.payGateDisabled,
          })}
          onClick={() => handlePaymentChange(PaymentType.PayGate)}
          data-testid={DataTestIds.CARD_PAYMENT_TYPE_OPTION}>
          <input
            type="radio"
            name="paymentType"
            id={EshopFormIds.CARD_PAYMENT_RADIO_ARRAY_OPTION}
            value={PaymentType.PayGate}
            checked={vm.chargeOrder.paymentType === PaymentType.PayGate}
            onChange={() => handlePaymentChange(PaymentType.PayGate)}
            disabled={vm.payGateDisabled}
            className={styles.hiddenRadio}
          />
          <img src={speedometerFastIcon} alt="" className={styles.speedIcon} />
          <div className={styles.paymentContent}>
            <div className={styles.paymentTitleRow}>
              <h3 className={styles.paymentTitle}>{vm.translateAttribute("card")}</h3>
              <div className={styles.paymentLogos}>
                <PaymentMethodIcon source={visa} height={30} mx="" />
                <PaymentMethodIcon source={masterCard} height={30} mx="" />
                <PaymentMethodIcon source={applePay} height={30} mx="" />
              </div>
            </div>
            <div className={styles.paymentDescription}>{vm.translateAttribute("fastPaymentMethod")}</div>
          </div>
        </div>

        {/* Google Pay */}
        {vm.enableGooglePay && (
          <div
            className={classNames(styles.paymentCard, {
              [styles.selected]: vm.chargeOrder.paymentType === PaymentType.GooglePay,
              [styles.disabled]: vm.payGateDisabled,
            })}
            onClick={() => handlePaymentChange(PaymentType.GooglePay)}
            data-testid={DataTestIds.GOOGLE_PAY_PAYMENT_TYPE_OPTION}>
            <input
              type="radio"
              name="paymentType"
              id={EshopFormIds.GOOGLE_PAY_PAYMENT_RADIO_ARRAY_OPTION}
              value={PaymentType.GooglePay}
              checked={vm.chargeOrder.paymentType === PaymentType.GooglePay}
              onChange={() => handlePaymentChange(PaymentType.GooglePay)}
              disabled={vm.payGateDisabled}
              className={styles.hiddenRadio}
            />
            <img src={speedometerFastIcon} alt="" className={styles.speedIcon} />
            <div className={styles.paymentContent}>
              <div className={styles.paymentTitleRow}>
                <h3 className={styles.paymentTitle}>{vm.translateAttribute("googlePay")}</h3>
                <div className={styles.paymentLogos}>
                  <img src={icGooglePay} alt="Google Pay" />
                </div>
              </div>
              <div className={styles.paymentDescription}>{vm.translateAttribute("fastPaymentMethod")}</div>
            </div>
          </div>
        )}

        {/* Bankovním převodem */}
        <div
          className={classNames(styles.paymentCard, {
            [styles.selected]: vm.chargeOrder.paymentType === PaymentType.Transfer,
            [styles.disabled]: vm.transferDisabled,
          })}
          onClick={() => handlePaymentChange(PaymentType.Transfer)}
          data-testid={DataTestIds.BANK_TRANSFER_PAYMENT_TYPE_OPTION}>
          <input
            type="radio"
            name="paymentType"
            id={EshopFormIds.BANK_TRANSFER_PAYMENT_RADIO_ARRAY_OPTION}
            value={PaymentType.Transfer}
            checked={vm.chargeOrder.paymentType === PaymentType.Transfer}
            onChange={() => handlePaymentChange(PaymentType.Transfer)}
            disabled={vm.transferDisabled}
            className={styles.hiddenRadio}
          />
          <img src={speedometerSlowIcon} alt="" className={styles.speedIcon} />
          <div className={styles.paymentContent}>
            <div className={styles.paymentTitleRow}>
              <h3 className={styles.paymentTitle}>{vm.translateAttribute("transferTitle")}</h3>
            </div>
            {vm.paymentTypeLabel && (
              <div className={styles.paymentDescription}>
                <ReactMarkdown
                  components={{
                    a: ({ node, ...props }) => (
                      <a
                        {...props}
                        href="#"
                        onClick={e => {
                          e.preventDefault();
                          vm.navigateToChargeTypeSelection();
                        }}
                      />
                    ),
                  }}>
                  {vm.paymentTypeLabel}
                </ReactMarkdown>
              </div>
            )}
            {!vm.transferDisabled && (
              <div className={styles.paymentDescription}>{vm.translateAttribute("slowPaymentMethod")}</div>
            )}
          </div>
        </div>
      </div>
      {validationError && (
        <Form.Control.Feedback type="invalid" className="mb-3">
          {validationError}
        </Form.Control.Feedback>
      )}
    </>
  );
});

registerView(SelectPaymentMethod, SelectPaymentMethodViewModel);
